import { Box, Rating, SxProps } from '@mui/material';
import { useKaziNavigate } from '../../../Hooks/useKaziNavigate';
import { Talent } from '../../../Types/Talent';
import { toPascalCase } from '../../../Utils/String';
import { calculateAverageScoreAndReviews } from '../../../Utils/TalentUtils';
import { KaziAvatar } from '../KaziAvatar';
import { KaziCard } from './KaziCard';

interface IKaziTalentCard {
  talent: Talent;
  sx?: SxProps;
}
export const KaziTalentCard = ({ talent, sx }: IKaziTalentCard) => {
  /* ******************** Hooks ******************** */
  const { navigateWithBack } = useKaziNavigate();
  /* ******************** Variables ******************** */
  const { averageScore } = calculateAverageScoreAndReviews(talent);
  /* ******************** Functions ******************** */
  /* ******************** Effects ******************** */
  /* ******************** JSX ******************** */
  return (
    <KaziCard
      title={`${toPascalCase(talent.first_name ?? '')} ${
        talent.last_name?.charAt(0).toUpperCase() ?? ''
      }.`}
      badge={
        averageScore > 0 && (
          <Box marginRight={1}>
            <Rating value={averageScore} readOnly precision={0.1} />
          </Box>
        )
      }
      subtitle={talent.title}
      body={talent?.resume?.languages.map(lang => lang.name).join(', ')}
      tags={talent?.resume?.skills}
      cardAction={() => navigateWithBack(`/profile/talent/${talent.locator}`)}
      sx={{
        maxHeight: '221px',
        width: '308px',
        ...sx,
      }}
      icon={
        <KaziAvatar
          locator={talent?.locator}
          first_name={talent?.first_name ?? ''}
          last_name={talent?.last_name ?? ''}
          src={talent?.profile_picture}
          width="24px"
          sx={{ fontSize: 12 }}
        />
      }
    />
  );
};
